import React from 'react';

import classnames from 'classnames';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { FormattedMessagePropType } from '../../../../prop-types/intl';
import { useOtherShippingOptionsStyleContext } from '../../style-provider';
import messages from '../messages';
import ReadOnlyRow from './read-only-row';
import ReadOnlySection from './read-only-section';

import style from '../../other-shipping-options.module.less';

const ReadOnlyOtherShippingOptions = ({
  optionData,
  sectionsToShow,
  shouldShowDdp = true,
  shippingAccountName,
  shippingAccountNumber,
  shippingAccountCountry,
  shippingAccountPostalCode,
}) => {
  const { classes } = useOtherShippingOptionsStyleContext();

  return (
    <div className={classnames(style['read-only-form'], classes.form)}>
      {shippingAccountName && (
        <ReadOnlyRow title={<FormattedMessage {...messages.shippingAccountLabel} />}>{shippingAccountName}</ReadOnlyRow>
      )}
      {shippingAccountNumber && (
        <ReadOnlyRow title={<FormattedMessage {...messages.accountNumberLabel} />}>{shippingAccountNumber}</ReadOnlyRow>
      )}
      {shippingAccountCountry && (
        <ReadOnlyRow title={<FormattedMessage {...messages.countryLabel} />}>{shippingAccountCountry}</ReadOnlyRow>
      )}
      {shippingAccountPostalCode && (
        <ReadOnlyRow title={<FormattedMessage {...messages.postalCodeLabel} />}>{shippingAccountPostalCode}</ReadOnlyRow>
      )}
      <ReadOnlySection
        optionData={optionData}
        section='shipment-options'
        sectionsToShow={sectionsToShow}
        shouldShowDdp={shouldShowDdp}
        title={<FormattedMessage {...messages.shipmentOptionsTitle} />}
      />
      <ReadOnlySection
        optionData={optionData}
        section='notification-options'
        sectionsToShow={sectionsToShow}
        shouldShowDdp={shouldShowDdp}
        title={<FormattedMessage {...messages.notificationOptionsTitle} />}
      />
      <ReadOnlySection
        optionData={optionData}
        section='delivery-options'
        sectionsToShow={sectionsToShow}
        shouldShowDdp={shouldShowDdp}
        title={<FormattedMessage {...messages.deliveryOptionsTitle} />}
      />
      <ReadOnlySection
        optionData={optionData}
        section='label-options'
        sectionsToShow={sectionsToShow}
        shouldShowDdp={shouldShowDdp}
        title={<FormattedMessage {...messages.labelOptionsTitle} />}
      />
      <ReadOnlySection
        optionData={optionData}
        section='marketplace-options'
        sectionsToShow={sectionsToShow}
        shouldShowDdp={shouldShowDdp}
        title={<FormattedMessage {...messages.marketplaceOptionsTitle} />}
      />
      <ReadOnlySection
        optionData={optionData}
        section='external-fulfillment-options'
        sectionsToShow={sectionsToShow}
        shouldShowDdp={shouldShowDdp}
        title={<FormattedMessage {...messages.externalFulfillmentOptionsTitle} />}
      />
    </div>
  );
};

ReadOnlyOtherShippingOptions.propTypes = {
  optionData: PropTypes.object.isRequired,
  shippingAccountName: PropTypes.oneOfType([PropTypes.string, FormattedMessagePropType]),
  sectionsToShow: PropTypes.arrayOf(PropTypes.string).isRequired,
  shippingAccountNumber: PropTypes.string,
  shippingAccountCountry: PropTypes.string,
  shippingAccountPostalCode: PropTypes.string,
  shouldShowDdp: PropTypes.bool,
};

export default ReadOnlyOtherShippingOptions;
